// extracted by mini-css-extract-plugin
export default {"banner":"ChatNotificationPermissionBanner_banner__WQaei","actions":"ChatNotificationPermissionBanner_actions__HGwMZ"};